import { styled } from '@porsche-code/kado-styled-system/jsx';
import { PIcon, PLinkPure } from '@porsche-design-system/components-react';
import { Link, useRouterState, useSearch } from '@tanstack/react-router';
import React from 'react';

const Wrapper = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: 'xs',
    marginBottom: 'md',
  },
});

export const Breadcrumbs = ({
  kadoName,
  appName,
}: {
  kadoName: React.ReactNode;
  appName: React.ReactNode;
}) => {
  const matches = useRouterState({ select: (s) => s.matches });
  const search = useSearch({ strict: false });

  const crumbs = matches
    .map((match) =>
      match.context && 'breadcrumb' in match.context
        ? {
            match,
            breadcrumb: match.context.breadcrumb as () => React.ReactElement,
          }
        : null,
    )
    .filter((d) => d !== null)
    // only keep the first breadcrumb, discard breadcrumbs that are only inherited
    .filter(
      (d, i, a) => i === a.findIndex((o) => o.breadcrumb === d.breadcrumb),
    );

  return (
    <Wrapper>
      <PLinkPure size="xs" href="/" icon="none">
        {kadoName}
      </PLinkPure>
      <PIcon name="arrow-head-right" size="2xs" />
      <PLinkPure size="xs" icon="none">
        <Link to="/" search={search}>
          {appName}
        </Link>
      </PLinkPure>
      {crumbs.map(({ match, breadcrumb }) => (
        <React.Fragment key={match.routeId}>
          <PIcon name="arrow-head-right" size="2xs" />
          <PLinkPure size="xs" icon="none" data-testid="breadcrumb">
            <Link to={match.pathname} search={search}>
              {breadcrumb()}
            </Link>
          </PLinkPure>
        </React.Fragment>
      ))}
    </Wrapper>
  );
};
